import CircularProgress from 'material-ui/CircularProgress';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Entities,
    fetchByCompanyId,
    fetchById,
    getEntities,
    getUpdatedEntity,
    patch,
    Projection,
    save,
    TOMCAT_URL,
} from 'src/common';
import ErrorMessage from 'src/components/misc/error-message';
import autoBind from 'react-autobind';
import { getOwnCompany } from 'src/selectors/bus-companies';
import CalendarSeasonForm from 'src/components/administration/calendar-season/components/calendar-season-form';

class CalendarSeasonModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        const { isCreate, id, selectedCompany, fetchById } = this.props;
        this.props.fetchByCompanyId(Entities.CALCULATION, selectedCompany);

        if (!isCreate) fetchById(id, Entities.CALENDAR_SEASON, selectedCompany, Projection.FULL);
        else this.setState({ startedFetching: true });
    }

    componentWillReceiveProps(nextProps) {
        const { calendarSeason } = nextProps;

        if (!this.state.startedFetching && calendarSeason.isFetching) this.setState({ startedFetching: true });
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { calendarSeason, isCreate, selectedCompany, t, calculations, buses, busCompany } = this.props;

        const finishFetching = this.state.startedFetching && !calendarSeason.isFetching && !calculations.isFetching;
        if (finishFetching) {
            if (calendarSeason.error) return <ErrorMessage object={calendarSeason} />;
            else {
                let initialValues, calculation;
                if (!isCreate && calendarSeason.content) {
                    initialValues = {
                        id: calendarSeason.content.id,
                        name: calendarSeason.content.name,
                        calendarColor: calendarSeason.content.calendarColor,
                        company: `${TOMCAT_URL}api/${Entities.BUS_COMPANY.repository}/${selectedCompany}`,
                    };
                } else {
                    initialValues = {
                        company: `${TOMCAT_URL}api/${Entities.BUS_COMPANY.repository}/${selectedCompany}`,
                    };
                }
                return (
                    <CalendarSeasonForm
                        t={t}
                        initialValues={initialValues}
                        onSubmit={this.handleSubmit}
                        ref={ref => (this.childForm = ref)}
                        selectedCompany={selectedCompany}
                        calculations={calculations}
                    />
                );
            }
        } else return <CircularProgress />;
    }

    handleSubmit(data) {
        const { isCreate, handleClose, patch, save, selectedCompany, busCompany } = this.props;
        data.calculation = `${TOMCAT_URL}api/${Entities.CALCULATION.repository}/${data.calculation}`;
        const request = {
            ...data,
            calculation: `${TOMCAT_URL}api/${Entities.CALCULATION.repository}/${data.calculation}`,
        };
        if (!isCreate) {
            patch(request, Entities.CALENDAR_SEASON, selectedCompany, Projection.LIST).then(() => {
                this.props.fetchByCompanyId(Entities.CALENDAR_SEASON, this.props.selectedCompany, Projection.LIST);
            });
        } else {
            this.props.save(data, Entities.CALENDAR_SEASON, selectedCompany, Projection.LIST).then(() => {
                this.props.fetchByCompanyId(Entities.CALENDAR_SEASON, this.props.selectedCompany, Projection.LIST);
            });
        }
        handleClose();
    }
}

const mapStateToProps = state => {
    return {
        calendarSeason: getUpdatedEntity(state, Entities.CALENDAR_SEASON, state.selectedCompany),
        selectedCompany: state.selectedCompany,
        calculations: getEntities(state, Entities.CALCULATION, state.selectedCompany),
        busCompany: getOwnCompany(state),
    };
};

export default connect(
    mapStateToProps,
    {
        fetchById,
        fetchByCompanyId,
        patch,
        save,
    },
    null,
    { withRef: true },
)(CalendarSeasonModal);
